export const mockNews = [
  {
    id: 1,
    date: '2024.12.15',
    category: 'お知らせ',
    title: '年末年始休業のお知らせ',
    content: '12月29日〜1月3日まで年末年始休業とさせていただきます。'
  },
  {
    id: 2,
    date: '2024.12.01',
    category: 'イベント',
    title: 'クリスマスパーティー開催決定',
    content: '12月22日にクリスマスパーティーを開催いたします。'
  },
  {
    id: 3,
    date: '2024.11.20',
    category: 'キャンペーン',
    title: '無料体験レッスン実施中',
    content: '新規入会をお考えの方は無料体験レッスンをご利用ください。'
  },
  {
    id: 4,
    date: '2024.11.10',
    category: 'お知らせ',
    title: '授業振替のお知らせ',
    content: '11月14日の授業は11月18日に振替いたします。'
  }
];